import GSAP from 'gsap';
import Component from '@averyano/core/src/classes/Component';

export default class Hamburger extends Component {
	constructor() {
		super({
			element: 'nav',
			elements: {
				menu: '.nav__menu',
				menuLines: '.nav__menu__line',
			},
		});

		this.isAnimating = false;
		this.isOpen = false;

		this.$on('resetState', this.resetState.bind(this));
	}

	create() {
		this.createAnimation();
		this.addEventListeners();
	}

	resetState() {
		if (this.isOpen) this.toggleState();
	}

	toggleState() {
		if (window.isFullscreen || this.isAnimating) return;

		window.globalAnalyticsInstance.trackEvent('Navigation', {
			action: 'Click',
			label: 'Menu Icon',
		});

		this.isAnimating = true;
		this.isOpen = !this.isOpen;

		if (this.isOpen) {
			this.$emit('stopScroll');
			this.$emit('openMenu');
		} else if (!this.isOpen) {
			this.$emit('startScroll');
			this.$emit('closeMenu');
		}

		this.animateHamburger();
	}

	createAnimation() {
		this.tl = GSAP.timeline({
			paused: true,
		});
		this.tl.fromTo(
			this.elements.menuLines[0],
			{
				marginTop: '-8px',
				rotate: 0,
				backgroundColor: '#ffffff',
			},
			{
				rotate: 45,
				marginTop: '0px',
				duration: 0.5,
				ease: 'out.power4',
				backgroundColor: '#111111',
			},
			0
		);

		this.tl.fromTo(
			this.elements.menuLines[1],
			{
				opacity: 1,
				backgroundColor: '#ffffff',
			},
			{
				opacity: 0,
				duration: 0.29,
				backgroundColor: '#111111',
				ease: 'out.power4',
			},
			0
		);

		this.tl.fromTo(
			this.elements.menuLines[2],
			{
				marginTop: '8px',
				rotate: 0,
				backgroundColor: '#ffffff',
			},
			{
				rotate: -45,
				marginTop: '0px',
				duration: 0.5,
				ease: 'out.power4',
				backgroundColor: '#111111',
			},
			0
		);
	}

	// animateHamburger() {
	// 	console.log('animateHamburger');
	// }

	animateHamburger = () => (this.isOpen ? this.tl.play() : this.tl.reverse());

	addEventListeners() {
		this.elements.menu.addEventListener('click', this.toggleState.bind(this));
	}
}
